var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpreadsheet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 44,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 2.5,
  clipPath: "url(#svg-public/img/unlimited-docs/banner/spreadsheet.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122.286 35.037c24.54-4.385 62.938.069 62.938.069M192.474 16.005c1.743-.97 5.471-3.212 7.749-4.478M195.154 22.311l5.41.476M187.323 11.423l.8-5.373"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/unlimited-docs/banner/spreadsheet.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h256v44H0z"
})))));
export { SvgSpreadsheet as ReactComponent };